import React from 'react';
import Typography from '@material-ui/core/Typography';
import "./vision-card.scss";
import { Card, CardContent } from '@material-ui/core';


  
  export default function VissionCard({visionImage,visionDesc,visionTitle}) {
  
    return (
    <div className="vision-card">
            
            <Card className="vision-card-mycard">
                    <img src={visionImage} alt="Process Image for Fund" className="vision-card-image" />
                    <h4 className="vision-card-title">{visionTitle}</h4>
                    <CardContent>
                        <Typography  variant="h5" component="h2">
                            {visionDesc}
                        </Typography>
                    </CardContent>
                    
            </Card>
               
          
               
    </div>
    );
  }